// Vuex
import store from '@/store.js';
import consts from "@/consts.js";
import Request from './request';

async function my(noLoading) {// 检查本地accessToken的登录状态
    const response = await Request('get', "api/account-users/my", null, noLoading);
    if (response.data && response.data.status.isOK()) {
        store.commit("USERINFO", response.data);
    }
    return response;
}

async function fetch(data) {
    return Request('get', "api/account-users", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    // data.fieldFilter = ["name",]; //仅筛选少许必要字段
    return Request('get', "api/account-users/select", data);
}

async function fetchOne(id) {
    return Request('get', "api/account-users/" + id);
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/account-users/edit?id=" + id, data);
    } else {
        return Request('post', "api/account-users/add", data);
    }
}

async function editSelf(data) {// 编辑个人账号
    return Request('post', "api/account-users/edit-self", data);
}

async function del(id) {// 删除数据
    return Request('delete', "api/account-users/del/" + id);
}

export default {
    my,
    fetch,
    fetchAll,
    fetchOne,
    save,
    editSelf,
    del,
};